// MF MED GmbH – Läufer-Icon (Direkthilfe), vektorisiert aus dem Original-Markenlogo.
// Erbt die Farbe über currentColor (passt sich der Buttonfarbe an).
export const RunIcon = ({ size = 16, ...props }) => (
  <svg width={size} height={size} viewBox="0 0 1929.013397 1945.372855" fill="currentColor" aria-hidden="true" {...props}>
    <g transform="translate(-0.237537,1945.773263) scale(0.100000,-0.100000)">
      <path d="M13740 19454 c-14 -2 -65 -9 -115 -15 -49 -6 -157 -28 -240 -49
-1003 -255 -1900 -1184 -2040 -2115 -19 -129 -19 -367 0 -478 78 -447 382
-785 817 -906 205 -57 494 -72 722 -37 734 114 1466 599 1911 1266 102 153
232 416 283 573 138 422 130 809 -22 1122 -164 335 -449 542 -856 620 -81 16
-403 29 -460 19z" />
      <path d="M9415 16140 c-44 -5 -147 -16 -230 -25 -1178 -127 -2532 -462 -3844
-952 -1431 -533 -2785 -1194 -4597 -2244 -192 -111 -412 -235 -488 -275 -191
-100 -242 -154 -253 -268 -5 -49 3 -68 210 -531 235 -526 251 -561 295 -621
40 -55 118 -94 189 -94 49 0 82 15 446 198 215 109 653 336 972 504 1535 808
2336 1202 3200 1575 1493 644 2678 992 3770 1108 234 25 744 31 935 11 902
-95 1443 -502 1624 -1221 49 -195 61 -309 60 -580 0 -198 -5 -284 -22 -412
-41 -305 -110 -614 -213 -948 -79 -259 -75 -236 -54 -290 10 -27 33 -65 52
-86 62 -69 130 -93 574 -204 1315 -328 2391 -509 3519 -592 308 -22 1282 -26
1530 -5 809 67 1350 185 1850 402 295 128 353 177 352 298 0 62 29 7 -332 608
-269 446 -304 492 -392 519 -76 22 -152 19 -233 -11 -436 -159 -747 -225
-1295 -276 -213 -20 -1011 -17 -1290 5 -486 38 -922 92 -1435 178 -320 53
-996 186 -1007 197 -3 4 -1 48 4 97 6 50 12 243 12 430 1 365 -10 503 -59 771
-246 1330 -1158 2290 -2494 2623 -167 42 -331 71 -531 97 -146 18 -700 27
-825 14z" />
      <path d="M9760 13971 c-98 -21 -153 -69 -481 -431 -1966 -2167 -3069 -3769
-3349 -4865 -54 -210 -70 -340 -70 -563 0 -281 25 -414 110 -588 177 -364 547
-612 1043 -700 207 -36 511 -38 726 -3 287 45 823 164 1746 385 1232 296 1700
396 2174 464 303 43 433 54 656 54 220 1 334 -12 460 -51 216 -68 298 -155
357 -378 21 -82 23 -111 23 -315 -1 -189 -4 -243 -22 -340 -168 -884 -786
-1973 -1860 -3278 -122 -149 -143 -180 -149 -218 -13 -89 12 -159 85 -237 14
-16 224 -189 466 -385 l440 -357 75 0 c136 1 198 54 457 390 1014 1322 1653
2522 1917 3597 85 346 116 582 123 933 6 308 -5 448 -52 681 -139 687 -566
1208 -1120 1369 -536 155 -1432 205 -2325 130 -1005 -85 -2069 -291 -3298
-636 -118 -33 -216 -58 -219 -55 -16 16 118 332 251 591 428 835 1259 1929
2492 3280 110 121 245 267 299 325 54 58 104 119 111 137 34 80 11 183 -57
266 -43 52 -848 777 -874 787 -35 13 -99 18 -135 11z" />
      <path d="M8055 6259 c-203 -15 -406 -28 -450 -28 -162 -2 -303 -52 -417 -148
-31 -26 -128 -124 -214 -218 -469 -508 -1061 -1100 -1439 -1440 -1265 -1138
-2588 -1953 -4698 -2891 -153 -68 -282 -124 -287 -124 -19 0 -69 -53 -89 -95
-28 -61 -28 -137 3 -217 26 -69 518 -1002 545 -1032 9 -10 32 -26 51 -36 84
-43 176 -33 310 31 47 22 175 75 285 116 1763 668 3368 1640 4732 2866 184
164 738 715 904 897 484 532 949 1143 1238 1624 142 237 167 307 158 452 -7
119 -60 219 -138 260 -35 18 -45 17 -494 -17z" />
    </g>
  </svg>
);

export default RunIcon;
